import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { toAriaLabelText } from '@/utils/tts';
import { useTranslation } from 'react-i18next';

interface UsedTTSModalProps {
    isOpen: boolean;
    onClose: () => void;
    onHomeRedirect: () => void;
    onConfirm: () => void;
}

export function UsedTTSModal({ isOpen, onClose, onHomeRedirect, onConfirm }: UsedTTSModalProps) {
    const { t } = useTranslation();

    const description1AriaLabel = toAriaLabelText(t('usedTTS.description1'));
    const description2AriaLabel = toAriaLabelText(t('usedTTS.description2'));
    return (
        <Modal isOpen={isOpen} onClose={onClose} className="tts-modal max-w-[calc(680*var(--vw-unit))]">
            <div className="flex h-full flex-col">
                <header className="text-text-main01 px-[calc(56*var(--vh-unit))] pt-[calc(56*var(--vh-unit))] pb-[calc(8*var(--vh-unit))] text-[calc(32*var(--vh-unit))] leading-normal font-bold tracking-[calc(-1.276*var(--vh-unit))]">
                    <h1 data-modal-region tabIndex={0} data-interactive aria-label={t('usedTTS.title')} className="focus-border text-center font-bold">
                        {t('usedTTS.title')}
                    </h1>
                </header>
                <main className="px-[calc(112*var(--vw-unit))] py-[calc(40*var(--vh-unit))]">
                    <div className="mt-[calc(24*var(--vh-unit))]">
                        <h3
                            tabIndex={0}
                            data-interactive
                            aria-label={t('usedTTS.subTitle1')}
                            className="text-text-main01 focus-border mb-[calc(16*var(--vh-unit))] text-[calc(24*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-bold tracking-[calc(-0.114*var(--vh-unit))]"
                        >
                            {t('usedTTS.subTitle1')}
                        </h3>
                        <p
                            tabIndex={0}
                            data-interactive
                            aria-label={description1AriaLabel}
                            className="text-text-main01 focus-border text-[calc(18*var(--vh-unit))] leading-[calc(24*var(--vh-unit))] font-medium tracking-[calc(-0.108*var(--vh-unit))]"
                            dangerouslySetInnerHTML={{ __html: t('usedTTS.description1') }}
                        ></p>
                    </div>
                    <div className="mt-[calc(24*var(--vh-unit))]">
                        <h3
                            tabIndex={0}
                            data-interactive
                            aria-label={t('usedTTS.subTitle2')}
                            className="text-text-main01 focus-border mb-[calc(16*var(--vh-unit))] text-[calc(24*var(--vh-unit))] leading-[calc(30*var(--vh-unit))] font-bold tracking-[calc(-0.114*var(--vh-unit))]"
                        >
                            {t('usedTTS.subTitle2')}
                        </h3>
                        <p
                            tabIndex={0}
                            data-interactive
                            aria-label={description2AriaLabel}
                            className="text-text-main01 focus-border text-[calc(18*var(--vh-unit))] leading-[calc(24*var(--vh-unit))] font-medium tracking-[calc(-0.108*var(--vh-unit))]"
                            dangerouslySetInnerHTML={{ __html: t('usedTTS.description2') }}
                        ></p>
                    </div>
                </main>
                <footer className="flex justify-center gap-[calc(23*var(--vw-unit))] px-[calc(56*var(--vh-unit))] pt-[calc(24*var(--vh-unit))] pb-[calc(52*var(--vh-unit))]">
                    <ModalButton
                        variant="tertiary"
                        role="button"
                        aria-label={t('usedTTS.buttons.close')}
                        onClick={onHomeRedirect}
                        data-interactive
                        type="button"
                    >
                        {t('usedTTS.buttons.close')}
                    </ModalButton>
                    <ModalButton variant="secondary" role="button" aria-label={t('usedTTS.buttons.confirm')} onClick={onConfirm} data-interactive type="button">
                        {t('usedTTS.buttons.confirm')}
                    </ModalButton>
                </footer>
            </div>
        </Modal>
    );
}
